// --- 洗车点管理 --- //

export default [
  {
    name: 'carWashCentreManagement',
    path: '/carWashSuperviseSystem/:carWashId/carWashCentreManagement',
    meta: { title: '洗车点管理' },
    component: require('business/carWashSuperviseSystem/carWashCentreManagement/list.vue').default
  },
  {
    name: 'modifyCarWashCentre',
    path: '/carWashSuperviseSystem/:carWashId/carWashCentreManagement/modify',
    meta: { title: '编辑洗车点' },
    component: require('business/carWashSuperviseSystem/carWashCentreManagement/modify.vue').default
  }
]
